export function startsWith(first, second) {
  const loweredFirst = first.toLowerCase();
  const loweredSecond = second.toLowerCase();
  return loweredFirst.startsWith(loweredSecond);
}

import isWithinInterval from "date-fns/isWithinInterval";

const safeInterval = {
  start: new Date(2010, 0),
  end: new Date(2030, 0),
};

export function isWithinSafeInterval(timestamp) {
  return isWithinInterval(timestamp, safeInterval);
}

export function getInitials(name) {
  function notEmptyString(value) {
    return value !== "";
  }

  function getFirstLetter(string) {
    return string[0];
  }

  const nameParts = name.split(/\s/).filter(notEmptyString);

  const firstLetters = nameParts.map(getFirstLetter);

  return firstLetters.slice(0, 2).join("");
}

import matches from "lodash-es/matches";
import negate from "lodash-es/negate";

const emptyOperation = {
  client: {
    free: 0,
    tariff: 0,
    beyond: 0,
  },
  booker: {
    free: 0,
    tariff: 0,
    beyond: 0,
  },
};

export const isOperationEmpty = matches(emptyOperation);
export const isOperationNotEmpty = negate(matches(emptyOperation));
